export default "__VITE_ASSET__CvWPSDYX__"